import { size, filter } from 'lodash'

export const getSubtaskCount = (subtasks) => {
  const total = size(subtasks)
  const completed = size(filter(subtasks, 'completed'))
  return { completed, total }
}
